import { h, Component } from 'preact';
import HTML from 'components/core/html/html.js';
import s from 'components/bolt/airport/popUpWindows/watchAtHome/watchAtHome.sss';
import Store from 'store/store';

export default class WatchAtHome extends Component {

	constructor(props) {
		super(props);
		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	handleButtonClick(e, merchant) {
		e.stopPropagation();

		Store.emit('CUSTOM_EVENT', {
			category: 'watch-at-home',
			action: 'vendor-click',
			label: merchant.id
		});
		
		window.open(merchant.link, '_blank');
	}

	render({ section, imageRoot }) {
		const popUpCopy = section.popUp?.copy;

		return (
			<div class={s.container} onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
				{(popUpCopy.subtitle || popUpCopy.description) && (
					<div class={s.content}>
						<HTML
							class={s.subtitle}
							markdown
							content={popUpCopy.subtitle}
						/>
						
						<HTML
							class={s.description}
							markdown
							content={popUpCopy.description}
						/>
						
					</div>
				)}
				<div class={s.merchants}>
					{popUpCopy.merchants.map(merchant => (
						merchant.link && (
							<button class={s.merchantLink} key={`${merchant.id}-link`} onClick={(e) => this.handleButtonClick(e, merchant)}>
								<img src={`${imageRoot}/airport/watch/${merchant.id}.webp`} />
							</button> 
						)
					))}
				</div> 
			</div>
		);
	}
}